import L from 'leaflet';

/**
 * Leaflet's default marker images are referenced by relative URL, which breaks under a
 * bundler that hashes asset filenames. Rebuilding the icon from the packaged images
 * (resolved to real, hashed URLs by Vite) is the standard workaround.
 */
export const markerIcon = L.icon({
  iconUrl: new URL('leaflet/dist/images/marker-icon.png', import.meta.url).href,
  iconRetinaUrl: new URL('leaflet/dist/images/marker-icon-2x.png', import.meta.url).href,
  shadowUrl: new URL('leaflet/dist/images/marker-shadow.png', import.meta.url).href,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});
